import React from "react";
import { Link } from "react-router-dom";
import AuthInput from "../../Components/AuthInput";
import useAdminLogin from "./useAdminLogin.js";
import OTPInput from "../../Components/OTPInput";
import AuthScreenLayout from "../../Components/Auth/AuthScreenLayout";
import AuthBrandMark from "../../Components/Auth/AuthBrandMark";
import {
  authPrimaryButtonClass as primaryBtn,
  authSecondaryButtonClass as secondaryBtn,
} from "../../Components/Auth/authClasses";

export default function AdminLogin() {
  const {
    register,
    handleSubmit,
    onSubmit,
    errors,
    showOtpForm,
    otp,
    setOtp,
    onOtpSubmit,
    otpError,
    otpSuccess,
    resendLoading,
    settings,
    onResendOtp,
    onSkip,
    signupEmail,
  } = useAdminLogin({});

  return (
    <AuthScreenLayout cardMaxWidthClass="max-w-2xl">
      <AuthBrandMark settings={settings} />

      {showOtpForm ? (
        <form onSubmit={onOtpSubmit} className="space-y-6">
          <div className="text-center">
            <h1 className="text-xl font-semibold tracking-tight text-white sm:text-2xl">Verify OTP</h1>
            <p className="mt-2 text-sm leading-relaxed text-white/70">
              A verification code has been sent to{" "}
              <strong className="font-medium text-white">{signupEmail || "your email"}</strong>
            </p>
          </div>

          <OTPInput value={otp} onChange={setOtp} length={6} disabled={resendLoading} variant="glass" />

          {otpError ? <p className="text-center text-sm text-red-400">{otpError}</p> : null}
          {otpSuccess ? <p className="text-center text-sm text-emerald-400">{otpSuccess}</p> : null}

          <div className="space-y-3 pt-1">
            <button type="submit" className={primaryBtn} disabled={otp.length !== 6}>
              Verify OTP
            </button>
            <button type="button" className={secondaryBtn} onClick={onResendOtp} disabled={resendLoading}>
              {resendLoading ? "Resending…" : "Resend OTP"}
            </button>
            <button
              type="button"
              onClick={onSkip}
              className="w-full text-center text-sm text-white/65 transition hover:text-white"
            >
              Skip for now
            </button>
          </div>
        </form>
      ) : (
        <>
          <div className="mb-6 text-center sm:mb-8">
            <h1 className="text-lg font-semibold text-white sm:text-xl">Admin Portal</h1>
            <p className="mt-1 text-sm text-white/65">Professional Weather Intelligence Portal</p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <AuthInput
              label="Email"
              type="email"
              name="email"
              id="email"
              placeholder="Enter Your Email"
              errors={errors}
              register={register}
              variant="glass"
            />
            <AuthInput
              label="Password"
              type="password"
              name="password"
              id="password"
              placeholder="Enter Your Password"
              errors={errors}
              register={register}
              variant="glass"
            />
            <div className="pt-1">
              <button type="submit" className={primaryBtn}>
                Log In
              </button>
            </div>
          </form>

          <p className="mt-8 text-center text-sm text-white/75">
            <Link
              to="/"
              className="transition hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue"
            >
              Back to site
            </Link>
          </p>
        </>
      )}
    </AuthScreenLayout>
  );
}
